/** 갤러리 공용 — 앨범 모양은 관리시스템 공개 API 와 같다. */

/**
 * 앨범 구분. 관리시스템이 정한다:
 *  - WORK    작업 결과물 — 견적 › 도켓의 client docket 사진을 복사(필요하면 부분 블러)해 만든 앨범
 *  - GENERAL 공장·설비·일반 사진
 */
export const KINDS = [
  { value: 'WORK', label: 'Our work', lede: 'Parts that left the floor, straight from the delivery dockets.' },
  { value: 'GENERAL', label: 'Workshop', lede: 'The floor, the machines and the people who run them.' }
];

export const kindOf = item => (item && item.kind === 'WORK' ? 'WORK' : 'GENERAL');

export const kindLabel = value => {
  const k = KINDS.find(x => x.value === value);
  return k ? k.label : 'Workshop';
};

/** 대표 사진(썸네일). 대표가 없으면 첫 사진. */
export const coverOf = (item, size = 'thumb') => {
  if (!item) return '';
  const cover = size === 'web' ? item.coverUrl : item.coverThumbUrl;
  if (cover) return cover;
  const first = item.images && item.images[0];
  return first ? (size === 'web' ? first.imageUrl : first.thumbUrl) : '';
};

export const photoCount = item => (item && (item.imageCount || (item.images ? item.images.length : 0))) || 0;

export const photoLabel = item => {
  const n = photoCount(item);
  return `${n} photo${n === 1 ? '' : 's'}`;
};

/** 홈 스트립용 — 관리시스템의 정렬 순서 그대로 앞에서 n 개, 사진이 있는 앨범만 */
export function pickHome(items, n = 5) {
  const list = Array.isArray(items) ? items : [];
  return list.filter(i => coverOf(i)).slice(0, n);
}
